export const videoHeight = 720;
export const videoWidth = 1280;
